import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { SelectModule } from 'ng2-select';
import { HeaderComponent } from './header/header.component';
import { LocationPickerComponent } from './location-picker/location-picker.component';
import { CompanyLocationSelectorComponent } from './company-location-selector/company-location-selector.component';
import { DriverSelectBoxComponent } from './driver-select-box/driver-select-box.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { MapControls } from '../utilities/MapControls/MapConrols';
import { CompanySelectorComponent } from './comapany-selector/company-selector.component';
import { PassengerMapScreenComponent } from './passenger-map-screen/passenger-map-screen.component';
import { MatButtonModule } from '@angular/material/button';
import { ViewTripRouteComponent } from './view-trip-route/view-trip-route.component';
import { TripsComponent } from './trips/trips.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DriverEarningsComponent } from './driver-earnings/driver-earnings.component';
import { TripDetailsComponent } from './trip-details/trip-details.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatAutocompleteModule, MatMenuModule } from '@angular/material';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { DriverVehicleSelectComponent } from './driver-vehicle-select/driver-vehicle-select.component';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { TimePickerComponent } from './time-picker/time-picker.component'
import { AddStopsDialogComponent } from './add-stops-dialog/add-stops-dialog.component';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import { PassengerImagesComponent } from './passenger-images/passenger-images.component';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { PlacesAddressInputComponent } from './places-address-input/places-address-input.component';
@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    SelectModule,
    MatButtonModule,
    MatProgressBarModule,
    FormsModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatMenuModule
  ],
  exports: [
    HeaderComponent,
    LocationPickerComponent,
    CompanyLocationSelectorComponent,
    CompanySelectorComponent,
    DriverSelectBoxComponent,
    PassengerMapScreenComponent,
    ViewTripRouteComponent,
    TripsComponent,
    DriverEarningsComponent,
    TripDetailsComponent,
    DriverVehicleSelectComponent,
    DateTimePickerComponent,
    TimePickerComponent,
    AddStopsDialogComponent,
    NavBarComponent,
    PassengerImagesComponent,
    PhoneInputComponent,
    PlacesAddressInputComponent
  ],
  providers: [
    MapControls
  ],
  declarations: [
    HeaderComponent,
    LocationPickerComponent,
    CompanyLocationSelectorComponent,
    DriverSelectBoxComponent,
    LoginFormComponent,
    CompanySelectorComponent,
    PassengerMapScreenComponent,
    ViewTripRouteComponent,
    TripsComponent,
    DriverEarningsComponent,
    TripDetailsComponent,
    DriverVehicleSelectComponent,
    DateTimePickerComponent,
    TimePickerComponent,
    AddStopsDialogComponent,
    NavBarComponent,
    PassengerImagesComponent,
    PhoneInputComponent,
    PlacesAddressInputComponent
  ],
  entryComponents:[
    AddStopsDialogComponent,
    PassengerImagesComponent
  ]
})
export class SharedModule { }
